export default class Constant {
  static SCHEME = 'sailorc';
  static AUTHORITY = 'keeta.com';
  static PATH_KNB = '/browser';
  static KNB_QUERY_PARAM = 'inner_url';
  static MACHPRO_QUERY_PARAM = 'mach_bundle_name';

  static PATH_MACHPRO = '/machpro';

  /** 埋点参数值为空时传入-999 */
  static STATISTICS_NON_VALUE = '-999';

  //sailorc://keeta.com
  static SCHEME_HOST = `${this.SCHEME}://${this.AUTHORITY}`;
  //sailorc://keeta.com/machpro
  static SCHEME_MACHPRO = this.SCHEME_HOST + this.PATH_MACHPRO;
  //sailorc://keeta.com/machpro?mach_bundle_name={bundle_name}
  static SCHEME_MACHPRO_WITH_PRE = `${this.SCHEME_MACHPRO}?${this.MACHPRO_QUERY_PARAM}=`;

  static SCHEME_PAY = 'sailorpayment://cashier/launch';

  static SHOP_PAGE = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_shop';
  static HOME_PAGE = 'sailorc://keeta.com/home';
  static ORDER_LIST_PAGE = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_order_list';
  static ORDER_STATUS_PAGE = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_order_status';
  static ORDER_REFUND_DETAIL = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_order_refund_detail';
  static SEARCH_PAGE = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_search';
  static ORDER_CANCEL_REASON = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_order_cancel_reason';
  static ORDER_REVIEW = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_order_review';
  static MY_ORDER_REVIEW = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_my_review';
  static SHOP_STAR_PAGE = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_shop_star';
  static ORDER_MAP = 'sailorc://keeta.com/machpro?mach_bundle_name=mach_pro_sailor_c_order_map';
}

export const EVENT = {
  LatestOrderInfo: 'LatestOrderInfo'
};
